<template>
  <div id="app">
    <headers></headers>
    <div class="teaching-list">
      <div class="w_1400">

        <div class="previous-page" v-if="isdet">
          <a href="javascript:history.back(-1)"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
        </div>
        <div class="previous-page" v-else>
          <a href="#" style="float: left;" @click="isdet=true"><i class="el-icon-arrow-left" style="color: #fff;font-size: 30px;"></i></a>
        </div>

        <div class="teaching-list-left">
          <div class="teaching-list-user" v-if="userinfo">
            <p>
              <img :src="userinfo.avatar" alt="">
            </p>
            <h1>{{userinfo.nickname}}</h1>
          </div>

          <div class="teaching-list-nav">
            <h3>我的教学</h3>
            <ul>
              <!-- <li>
                <router-link to="/homecourse"><a href="javascript();">在教课程</a></router-link>
              </li> -->
              <li class="active">
                <router-link to="/homework"><a href="javascript();">课程作业</a></router-link>
              </li>
              <li>
                <router-link to="/practice"><a href="javascript();">实践作业</a></router-link>
              </li>
            </ul>
          </div>
        </div>
        <!-- 课程列表 -->
        <div class="teaching-list-right">
          <h3>作业详情</h3>

          <div class="teaching-list-table homework-table" v-if="isdet">
            <div class="teaching-list-form">
              <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select">

                <template slot="prepend">
                  <i class="el-icon-search"></i>
                </template>

                <el-button type="success" size="mini" slot="suffix" @click="searchs()">搜索</el-button>
              </el-input>
            </div>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column type="selection" width="50" />
              <el-table-column prop="id" label="编号" width="220">
              </el-table-column>
              <el-table-column prop="name" label="课程标题">
              </el-table-column>
              <el-table-column prop="time" label="发布时间">
                <template slot-scope="scope">{{ scope.row.time }}</template>
              </el-table-column>
              <!-- <el-table-column label="批阅状态(总作业量/待批阅)">

                <template slot-scope="scope" >
                  <span v-if="tableData[scope.$index].paper">
                  {{tableData[scope.$index].paper.totalcount}}/<font style="color: red;">
                    {{tableData[scope.$index].paper.unmarked_count}}
                  </font>
                  </span>
                  <span v-else>本课程没有作业</span>
                </template>
              </el-table-column> -->
              <el-table-column label="操作" width="240">
                <template slot-scope="scope">
                  <el-button @click="corrections(scope.$index, tableData)" type="text" size="small">
                    查看详情
                  </el-button>
                  <el-button @click="deleteRow(scope.$index, tableData)" type="text" size="small">
                    学生作业
                  </el-button>
                </template>
              </el-table-column>

            </el-table>
            <div style="text-align: center;">
              <el-pagination layout="prev, pager, next" :total="total" :page-size="15" @next-click="nextpage"
                @prev-click="prevpage" @current-change="currentchange">
              </el-pagination>
            </div>
          </div>
          <!-- 作业列表 -->
          <div class="teaching-list-table homework-table" v-else>
            <div class="teaching-list-form">
              <el-input placeholder="请输入内容" v-model="keyword1" class="input-with-select">

                <template slot="prepend">
                  <i class="el-icon-search"></i>
                </template>

                <el-button type="success" size="mini" slot="suffix" @click="searchs()">搜索</el-button>
              </el-input>
            </div>
            <div v-if="correctStatus==true">
              <el-button  type="text"
                size="middle" @click="part()">
                批量批改
              </el-button>
            </div>
            <div v-if="correctStatus==true">
              <el-button  type="text"
                size="middle" @click="all()">
                一键批改
              </el-button>
            </div>
            <el-table :data="tableData2"
              class="table"
              ref="table"
              :row-class-name="row_class_name2"
              @selection-change="selection_change2"
              @row-click="row_click2">
              <el-table-column type="selection" width="50" />
              <el-table-column prop="nickname" label="学员昵称" width="220">
              </el-table-column>
              <el-table-column prop="sn" label="学号" width="220">
              </el-table-column>
              <el-table-column prop="time" label="提交时间" width="220">
              </el-table-column>
              <el-table-column label="作业状态">
                <template slot-scope="scope">
                  <font :style="scope.row.audit==1?'color:#80D676;':''">
                    {{scope.row.audit==1?'未批阅':'已批阅'}}
                  </font>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button v-if="tableData2[scope.$index].audit==2"
                    @click.native.prevent="correction(scope.$index, tableData)" type="text" size="small">
                    查看详情
                  </el-button>
                  <el-button v-else @click.native.prevent="correction(scope.$index, tableData)" type="text"
                    size="small">
                    立即批改
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;">
              <el-pagination layout="prev, pager, next" :total="total1" @next-click="nextpage" @prev-click="prevpage"
                :page-size="15" @current-change="currentchange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import {
    teacherpaper,
    paperList,
    allcourse,
    coursepartcorrect
  } from '../../request/api';

  export default {
    name: 'app',
    components: {
      headers,
      footers
    },
    data() {
      return {
        tableData: [],
        search: '',
        userinfo: '',
        isdet: true,
        selection2: [],
        tableData2: [],
        total: 0,
        total1: 0,
        index1: 0,
        page: 1,
        page1: 1,
        keyword:'',
        keyword1:'',
        correctStatus:true
      }
    },
    methods: {
      part(){
        //    1.弹出提示框
        this.$confirm("确定批量修改作业？","提示",{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:"info"
        }).then(()=> {
          this.partcorrect(this.selection2)
        }).finally(()=> {
          this.paperLists()
        }).catch(()=> {
          //    3.取消批改作业
          this.$message.info("取消批改作业");
        })
      },
      all(){
        //    1.弹出提示框
        this.$confirm("确定一键修改作业？","提示",{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:"info"
        }).then(()=> {
          this.partcorrect(this.tableData2)
        }).finally(()=> {
          this.paperLists()
        }).catch(()=> {
          //    3.取消批改作业
          this.$message.info("取消批改作业");
        })
      },
      //批量或者一键批改作业
      partcorrect(data){
        coursepartcorrect(data).then(res => {
              this.$message.info(res.msg);
          })
          setTimeout(() => {
            location.reload();
          }, 1500)
      },
      row_class_name2({ row, rowIndex }) {
          return this.selection2.find(v => v.value == row.value) ? 'selected' : '';
      },
      selection_change2(selection) {
          this.selection2 = selection;
      },
      row_click2(row, column, event) {
          this.$refs.table.toggleRowSelection(row)
      },
      corrections(index, rows) {
        console.log(index,rows)
        this.$router.push({
          name: 'courseshow',
          query: {
            id: this.tableData[index].id
          }
        })
      },
      // page被改变时触发的方法
      currentchange(event){
        if(this.isdet){
          this.page=event
          this.teacherpapers()
        }else{
          this.page1=event
          this.paperLists()
        }
      },
      // 点击了下一页时触发的方法
      nextpage() {
        if(this.isdet) {
          this.page++
          this.teacherpapers()
        } else {
          this.page1++
          this.paperLists()
        }
      },
      // 点击了上一页时触发的方法
      prevpage() {
        if(this.isdet) {
          this.page--
          this.teacherpapers()
        } else {
          this.page1--
          this.paperLists()
        }

      },

      searchs() {
        if(this.isdet){
          this.page = 1
          this.teacherpapers()
        } else{
          this.page1 = 1
          this.paperLists(this.index1)
        }
      },
      // 老师点击查看课程的方法
      deleteRow(index, rows) {
        console.log(rows)
        // if(rows[index].paper){
          this.isdet = false;
          this.index1 = this.tableData[index].id
          this.paperLists(this.tableData[index].id)
        // }else{
        //   this.$message.error('该课程没有作业');
        // }
      },
      // 老师点击查看作业详情的方法
      correction(index, rows) {
        console.log(index)
        this.isdet = false;
        window.open(this.$router.resolve({
          name: 'operation',
          query: {
            paper_id: this.tableData2[index].id,
            id: this.tableData2[index].user_id
          }
        }).href,"_blank")
      },
      // 获取对应课程所有作业
      paperLists(id) {
        let self = this
        if(id){
          this.paper_id=id
        }else{

        }
        paperList({
          'course_id': this.paper_id,
          'page': this.page1,
          'pagesize': 15,
          'keyword1':this.keyword1
        }).then(res => {
          console.log(res)
          this.tableData2 = res.data.data.data.map(item => {
            item.time = self.timestampToTime(item.answerCreatetime)
            return item;
          })
          this.tableData2.all=1
          this.tableData2.paper_id=this.paper_id
          this.total1 = res.data.data.total
          // this.correctStatus = res.data.correctStatus

        })
      },
      // 时间戳转日期格式
      timestampToTime(timestamp) {
        // 时间戳为10位需*1000，时间戳为13位不需乘1000
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + ".";
        var M =
          (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + ".";
        var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        var h = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var s = date.getSeconds();
        return Y + M + D;
      },
      //获取课程列表
      teacherpapers() {
        let self = this
        allcourse({
          'page': this.page,
          'pageSize': 15,
          'keyword':this.keyword
        }).then(res => {
          this.tableData = res.data.data.map(item => {
            item.time = self.timestampToTime(item.createtime)
            return item;
          })
          this.total = res.data.total
        })
      }
    },
    // 初始化方法，加载完成时触发
    created() {
      this.teacherpapers();
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
    }
  }
</script>

<style>
  @import '../../assets/css/home.css';

  .el-button--small {
    width: 99.86px;
    height: 28.04px;
    background: #80D676;
    border-radius: 3.116px;
    color: #FDFDFD;
    display: inline-block;
  }
  .el-button--middle {
    float:left;
    margin: 0px 15px;
    width: 99.86px;
    height: 40px;
    background: #7bb2d6;
    border-radius: 3.116px;
    color: #FDFDFD;
    display: inline-block;
  }
  .teaching-list-form .el-input {
    width: 330px;
  }

  .el-input-group--prepend .el-input__inner {
    border: none;
  }

  .input-with-select .el-input-group__prepend {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/homework.vue